<script setup lang="ts">
  import { computed } from 'vue';
  import { RouterLink, type RouterLinkProps } from 'vue-router';
  import { useLink } from 'vue-router';
  import { components as comp } from '@/cypaths';

  defineOptions({ name: 'ElLink', inheritAttrs: false });

  const emits = defineEmits<{
    click: [e: Event];
  }>();

  const props = withDefaults(
    defineProps<
      RouterLinkProps & {
        activeClass?: string;
        matchExact?: boolean;
      }
    >(),
    { activeClass: '', matchExact: true },
  );

  const isExternalLink = computed<boolean>(() => typeof props.to === 'string' && props.to.startsWith('http'));
  const link = !isExternalLink.value ? useLink(props) : null;

  function handleClick(event: MouseEvent) {
    link?.navigate(event);
    emits('click', event);
  }

  /** Validation de la route exacte ou non, en fonction des props passée à la composante */
  const matchRoute = computed(() => (props.matchExact ? link?.isExactActive.value : link?.isActive.value));
</script>

<template>
  <template v-if="isExternalLink || to === ''">
    <span :data-cy="comp.APP_LINK">
      <a
        class="inline-flex flex-row gap-2"
        v-bind="$attrs"
        :href="to.toString() || 'javascript:void(0);'"
      >
        <slot />
      </a>
    </span>
  </template>
  <template v-else>
    <RouterLink
      :data-cy="comp.APP_LINK"
      v-bind="$props"
      custom
    >
      <a
        :aria-current="matchRoute ? 'page' : 'false'"
        v-bind="$attrs"
        :href="link?.href.value ?? ''"
        :class="matchRoute ? activeClass : ''"
        @click="handleClick"
      >
        <slot />
      </a>
    </RouterLink>
  </template>
</template>
